import { createAction } from '@reduxjs/toolkit'

export const getAllBikes = createAction('bikeCatalog/getAllBikes')
